import api from '@/shared/utils/apiConfig';

const resolvedCache = new Map<string, string>();
const inflightCache = new Map<string, Promise<string | null>>();

export async function fetchAuthenticatedObjectUrl(apiPath: string): Promise<string | null> {
  const cached = resolvedCache.get(apiPath);
  if (cached) return cached;

  let inflight = inflightCache.get(apiPath);
  if (!inflight) {
    inflight = api
      .get(apiPath, {
        responseType: 'blob',
        timeout: 30000,
      })
      .then((response) => {
        const url = URL.createObjectURL(response.data as Blob);
        resolvedCache.set(apiPath, url);
        inflightCache.delete(apiPath);
        return url;
      })
      .catch(() => {
        inflightCache.delete(apiPath);
        return null;
      });
    inflightCache.set(apiPath, inflight);
  }

  return inflight;
}

export function getCachedAuthenticatedObjectUrl(apiPath: string): string | null {
  return resolvedCache.get(apiPath) ?? null;
}

export function prefetchAuthenticatedObjectUrl(apiPath: string): void {
  void fetchAuthenticatedObjectUrl(apiPath);
}
